<template>
    <div class="page-user-lsit">
        <div class="pg-breadcrumb">
            <div class="breadcrumb-item em">後臺管理</div>
            <div class="breadcrumb-item">APP通知管理</div>
        </div>
    
        <!-- <div class="card-block">
            <Form inline class="pg-form-inline form-input-wrap">
                <FormItem>
                    <Select size="small" style="width: 120px;" placeholder="通知類型">
                        <Option :value="1">活動通知</Option>
                        <Option :value="2">系統通知</Option>
                    </Select>
                </FormItem>
                <FormItem>
                    <div class="pg-btn-wrap">
                        <div class="pg-btn style1">搜索</div>
                    </div>
                </FormItem>
            </Form>
        </div> -->

        <div class="card-block pd-bt">
            <Spin fix class="pg-sub-loading" v-if="isSubmiting">
                <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
                <div class="loading-text">Loading</div>
            </Spin>
            <div class="pg-toolbar">
                <div class="pg-btn-wrap">
                    <div class="pg-btn style1" @click="handleToAdd">新增</div>
                </div>
            </div>
            <Table size="small"
                   no-data-text="暫無數據"
                   border
                   maxHeight="680"
                   :columns="table.column"
                   :data="table.data">
                
                <template slot-scope="{ row, index }" slot="action">
                    <div class="pg-btn-wrap">
                        <div class="pg-btn style2" @click="handleEdit(row)">修改</div>
                        <div class="pg-btn style1" @click="handleDelete(row)">删除</div>
                    </div>
                </template>
                
                <template slot-scope="{ row, index }" slot="img">
                    <div v-if="row.image" class="demo-image__preview">
                        <el-image
                            style="width: 50px; height: 50px"
                            :src="row.image"
                            :preview-src-list="[row.image]">
                        </el-image>
                    </div>
                    <div v-else>无</div>
                </template>

                <template slot-scope="{ row, index }" slot="link">
                    <div class="pg-btn-wrap">
                        <a rel="shortcut icon" :href="row.link">{{ row.link }}</a>
                    </div>
                </template>
                
                <template slot="status" slot-scope="{row,index}">
                        <!--<Switchs true-color="#51f4a9" v-model="row.status" @on-change="statusChange(row)"/>-->
                    <span v-if="row.status==1">已开启</span>
                    <span v-if="row.status==0">已关闭</span>
                </template>
                <template slot="ispush" slot-scope="{row,index}">
                        <!--<Switchs true-color="#51f4a9" v-model="row.is_push" @on-change="ispushChange(row)"/>-->
                    <!--0关闭 1开启 2完成 3待处理，任务中断中，可重启-->
                    <span v-if="row.is_push==0">关闭</span>
                    <span v-if="row.is_push==1">开启</span>
                    <span v-if="row.is_push==2">完成</span>
                    <span v-if="row.is_push==3">待处理</span>
                </template>
            </Table>

            <div class="pg-pagger">
                <Row>
                    <Col span="12" class="pagger-left">
                        <div class="pagger-total">縂共 {{ totalCount }} 條記錄</div>
                    </Col>
                    <Col span="12" class="pagger-right">
                        <div>
                            <div class="pagger-sizer">
                                <span>每頁</span>
                                <Select v-model="curPageSize" size="small" placeholder="數量"
                                        @on-change="handlePageSizeChange">
                                    <Option :value="10">10</Option>
                                    <Option :value="20">20</Option>
                                    <Option :value="30">30</Option>
                                    <Option :value="40">40</Option>
                                    <Option :value="50">50</Option>
                                </Select>
                            </div>

                            <div class="pagger-elevator">
                                <span>跳轉</span>
                                <Input size="small" v-model="pageInput" @on-keyup="handlePageInput"
                                       @on-enter="handlePageEnter"/>
                            </div>

                            <Page size="small"
                                  :current="pageIndex"
                                  :page-size="curPageSize"
                                  :total="totalCount"
                                  @on-change="handlePageChange">
                            </Page>
                        </div>
                    </Col>
                </Row>
            </div>

        </div>
    </div>
</template>

<script>
    import wangEditor from "wangeditor";

    export default {
        data() {
            return {
                srcList: [],
                pageIndex: 1,   //页码
                curPageSize: 10,    //一页数量
                pageInput: '',  //输入的页码
                isSubmiting: false,
                totalCount: 0,
                status: false, // 是否開啓
                table: {
                    column: [
                        {
                            title: '操作',
                            slot: 'action',
                            align: 'center',
                            minWidth: 150
                        },
                        {
                            title: '是否開啓',
                            key: 'status',
                            align: 'center',
                            slot: 'status',
                            minWidth: 80
                        },
                        {
                            title: '推送狀態',
                            key: 'is_push',
                            align: 'center',
                            slot: 'ispush',
                            minWidth: 80
                        },
                        {
                            title: '通知類型',
                            key: 'activity',
                            align: 'center',
                            sortable: true,
                            minWidth: 150,
                            render: (h, {row, column, index}) => {
                                return h('span', row.activity == 1 ? '活動通知' : '系統通知')
                            }
                        },
                        {
                            title: '活動圖片',
                            key: 'image',
                            align: 'center',
                            slot: 'img',
                            sortable: true,
                            minWidth: 150
                        },
                        {
                            title: '標題',
                            key: 'title',
                            align: 'center',
                            sortable: true,
                            minWidth: 150
                        },
                        {
                            title: '通知内容',
                            key: 'content',
                            align: 'center',
                            sortable: true,
                            minWidth: 150,
                            ellipsis: true,
                            tooltip: true,
                        },
                        {
                            title: '頁面跳轉鏈接',
                            key: 'link',
                            align: 'center',
                            slot: 'link',
                            sortable: true,
                            minWidth: 150
                        },
                        {
                            title: '類型',
                            key: 'type',
                            align: 'center',
                            sortable: true,
                            minWidth: 80,
                            render: (h, {row, column, index}) => {
                                return h('span', row.type == 1 ? '一次' : '無限')
                            }
                        },
                        {
                            title: '通知開始時間',
                            key: 'notiTimeStrat',
                            align: 'center',
                            sortable: true,
                            minWidth: 160,
                        },
                        {
                            title: '通知結束時間',
                            key: 'notiTimeEnd',
                            align: 'center',
                            sortable: true,
                            minWidth: 160
                        },
                        {
                            title: '用戶瀏覽數',
                            key: 'frequency',
                            align: 'center',
                            sortable: true,
                            minWidth: 120
                        },
                
                
                    ],
                    data: []
                }
            };
        },
        activated() {
            this.getList();
        },
        mounted() {
            this.getList();
        },
        methods: {
            /*
             * 是否開啓通知
             * */
            handlesrcList(imgobj) {
                this.srcList = [];
                for (let i = 0; i < imgobj.length; i++) {
                    this.srcList.push(imgobj);
                }
            },
            ispushChange(item) {
            
            },
            statusChange(item) {
                let id = item.id;
                let status;
                if (item.status) {
                    status = 1;
                } else {
                    status = 2;
                }
                this.isSubmiting = true;
            
                this.$Rq.requestAuth({
                    url: this.$Api.appNotificationManageStatusEdit + '/' + id,
                    method: 'post',
                    data: {status}
                }).then((res) => {
                    this.isSubmiting = false;
                    this.getList();
                    if (res.code == 0) {
                        this.$Utils.showSuccess(res.msg);
                    } else {
                        this.$Utils.showTipInfo(res.msg);
                    }
                }).catch((err) => {
                    this.isSubmiting = false;
                });
            },
            getList() {
                let form = this.form;
                this.isSubmiting = true;
                this.$Rq.requestAuth({
                    url: this.$Api.appNotificationManageList,
                    method: 'get',
                    data: {
                        offset: (this.pageIndex - 1) * this.curPageSize,
                        limit: this.curPageSize,
                    }
                }).then((res) => {
                    this.isSubmiting = false;
                    if (res.code == 0) {
                        let tempArr = [];
                        let resData = res.data.data;
                        for (let i = 0; i < resData.length; i++) {
                            tempArr.push({
                                activity:resData[i].activity,
                                id: resData[i].id,
                                title: resData[i].title,
                                content: resData[i].content,
                                link: resData[i].link,
                                image: resData[i].image,
                                weights: resData[i].weights,
                                status: resData[i].status,
                                is_push: resData[i].is_push,
                                type: resData[i].type,
                                frequency: resData[i].frequency,
                                notiTimeStrat: resData[i].notiTimeStrat.slice(0,10),
                                notiTimeEnd: resData[i].notiTimeEnd.slice(0,10),
                            });
                        }
                        this.totalCount = res.data.count || 0;
                        this.table.data = tempArr;
                    } else {
                        this.showTipInfo(res.msg);
                    }
                }).catch((err) => {
                    this.isSubmiting = false;
                });
            },
            handleDelete(item) {
                let id = item.id;
                this.$Modal.confirm({
                    title: '提示',
                    content: '確定刪除嗎？',
                    cancelText: '取消',
                    okText: '確定',
                    onOk: () => {
                        let tableData = this.table.data;
                        this.isSubmiting = true;
                        this.$Rq.requestAuth({
                            url: this.$Api.appNotificationManageDel + `/${id}`,
                            method: 'post'
                        }).then((res) => {
                            this.isSubmiting = false;
                            if (res.code == 0) {
                                this.$Utils.showSuccess(res.msg);
                                this.getList();
                            } else {
                                this.$Utils.showTipInfo(res.msg);
                            }
                        }).catch((err) => {
                            this.isSubmiting = false;
                        });
                    }
                });
            },
            handleToAdd() {
                this.$router.push({path: '/appNotificationManageAdd'});
            },
            handleSearch() {
                this.pageIndex = 1;
                this.getList();
            },
            handleEdit(item) {
                this.$router.push({path: '/appNotificationManageEdit?id=' + item.id})
            },
            handlePageSizeChange(value) {
                this.pageIndex = 1;
                this.getList();
            },
            handlePageInput() {
                let value = ('' + this.pageInput).replace(/\D/g, '');
                let pageCount = Math.ceil(this.totalCount / this.curPageSize);
                if (value > pageCount) {
                    value = pageCount;
                }
                this.pageInput = value;
            },
            handlePageEnter() {
                if (this.pageInput == '' || this.pageInput == this.pageIndex) return;
                if (this.pageInput == 0) {
                    this.pageInput = 1;
                }
                this.pageInput = parseInt(this.pageInput);
                this.pageIndex = this.pageInput;
                this.getList();
            },
            handlePageChange(value) {
                this.pageIndex = value;
                this.getList();
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import 'appNotificationManage.scss';
</style>
